export default {
  API_URL: 'https://yorkshirewater-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://yorkshirewatersandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
